import { render } from "./TicketResolve.vue?vue&type=template&id=0daf9d80&scoped=true"
import script from "./TicketResolve.vue?vue&type=script&lang=js"
export * from "./TicketResolve.vue?vue&type=script&lang=js"

import "./TicketResolve.vue?vue&type=style&index=0&id=0daf9d80&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0daf9d80"]])

export default __exports__